import { type QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { type BasePerformanceRequestFilterParams } from "features/Library/Common/models";
import { type PerformanceFilter } from "features/Library/Common/utils/performanceUtils";
import { peopleReportingService } from "features/Reporting/services/peopleReportingService";

type PeopleAcquisitionDrilldownQueryKey = [
  name: string,
  filters: BasePerformanceRequestFilterParams,
  selectedCampaign: string,
  selectedMedium: string,
  selectedSource: string,
];

type UsePeopleAcquisitionDrilldownQueryParams = {
  dateFilter: PerformanceFilter;
  selectedCampaign: string;
  selectedMedium: string;
  selectedSource: string;
};

const getDetails = async ({ queryKey, signal }: QueryFunctionContext<PeopleAcquisitionDrilldownQueryKey>) => {
  const [_name, filters, campaign, medium, source] = queryKey;
  const { data } = await peopleReportingService.acquisition.getPeopleAcquisitionDetails(
    { ...filters, campaign, medium, source },
    signal!,
  );
  return data.map((d) => ({ ...d, id: `${d.UserId}-${d.ClickedAt}` }));
};

export const usePeopleAcquisitionDrilldownQuery = ({
  dateFilter,
  selectedCampaign,
  selectedMedium,
  selectedSource,
}: UsePeopleAcquisitionDrilldownQueryParams) => {
  return useQuery({
    queryFn: getDetails,
    queryKey: [
      "peopleAcquisitionUsersDrilldown",
      dateFilter,
      selectedCampaign,
      selectedMedium,
      selectedSource,
    ] as PeopleAcquisitionDrilldownQueryKey,
    enabled: !!selectedCampaign,
  });
};
